import { render } from "./FintriviaPage.vue?vue&type=template&id=52484bed"
import script from "./FintriviaPage.vue?vue&type=script&lang=js"
export * from "./FintriviaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__